import ReactOnRails from 'react-on-rails';
import {
    ArrowheadInner,
    ArrowlengthInner,
    CarvingInner,
    DecorationInner,
    FamilycrestInner,
    FeatherInner,
    FeatherinsideInner,
    InsertInner,
    KebikiInner,
    NockInner,
    ShaftInner,
    ThreadInner,
    TwineInner,
    RameInner,
    UnitInner,
    ZeroInner,
} from '@component/OrderPartsHelp';

ReactOnRails.register({ ArrowheadInner });
ReactOnRails.register({ ArrowlengthInner });
ReactOnRails.register({ CarvingInner });
ReactOnRails.register({ DecorationInner });
ReactOnRails.register({ FeatherInner });
ReactOnRails.register({ FeatherinsideInner });
ReactOnRails.register({ FamilycrestInner });
ReactOnRails.register({ InsertInner });
ReactOnRails.register({ KebikiInner });
ReactOnRails.register({ NockInner });
ReactOnRails.register({ ShaftInner });
ReactOnRails.register({ ThreadInner });
ReactOnRails.register({ TwineInner });
ReactOnRails.register({ UnitInner });
ReactOnRails.register({ RameInner });
ReactOnRails.register({ ZeroInner });
